import {UserStatusCodec} from '../codecs';
import {buildManagedStorage} from '../ManagedStorage';

// this is the only place using localStorage is allowed
// eslint-disable-next-line no-restricted-globals
const driver = localStorage;

const v = 'v21.30.0';
const ls = buildManagedStorage(v, driver, ({entry, codecs}) => ({
    // user info to persist between sessions
    authStatus: entry('auth_status', UserStatusCodec),
    givenName: entry('given_name'),
    username: entry('username'),

    /** @deprecated Was used to check sms delivery status. This feature never worked well. */
    tenantUuid: entry('tenant_uuid'),

    // preferences
    balanceCurrency: entry('balanceCurrency'),

    // checkboxes
    checkboxEthUsageAlertSeen: entry('checkbox:OneTimeAlert:EthUsageAlert', {
        decode: value => value === 'on',
        encode: value => (value ? 'on' : 'off'),
    }),
    /** The key was meant to be a store for all checkboxes, but ended up being used for just one */
    checkboxCardLimitationsSeen: entry('checkboxFlags'),
    checkboxTravelRuleWarningSeen: entry('travelRuleWarningSeen'),

    // biometry stuff
    biometryStatus: entry('biometryStatus'),
    biometryType: entry('biometryType'),
    callPointBiometry: entry('callPointBiometry'),
    dataBiometry: entry('dataBiometry'),
    hasTouchId: entry('hasTouchId', codecs.boolean),
    hasSecret: entry('hasSecret', codecs.boolean),
    runBiometryActivation: entry('runBiometryActivation'),
    saveSecretError: entry('saveSecretError'),
    timestampBiometryActivation: entry('timestampBiometryActivation'),

    /** some sort of crutch, half-related to biometry */
    authError: entry('authError'),
}));

export default {[v]: ls};
